import { render, staticRenderFns } from "./ChangeMobile.vue?vue&type=template&id=13340ed8&scoped=true"
import script from "./ChangeMobile.vue?vue&type=script&lang=ts"
export * from "./ChangeMobile.vue?vue&type=script&lang=ts"
import style0 from "./ChangeMobile.vue?vue&type=style&index=0&id=13340ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13340ed8",
  null
  
)

export default component.exports